export type GuardianPlayerLevelDetailStatus = 'earned' | 'working' | 'notStarted';

export type GuardianPlayerLevelDetailPinKey =
  | 'putting'
  | 'aroundTheGreen'
  | 'fullSwing'
  | 'scoring'
  | 'knowledge';

export type GuardianPlayerLevelDetailAttempt = {
  id: string;
  label: string;
  completed?: boolean;
  completedOn?: string;
  incompleteOn?: string;
  groupStart?: boolean;
};

export type GuardianPlayerLevelDetailPin = {
  key: GuardianPlayerLevelDetailPinKey;
  sourceIndex: number;
  title: string;
  status: GuardianPlayerLevelDetailStatus;
  pinPicture: string;
  pinImageUrl: string | null;
  date?: string;
  whatItTests?: string;
  criteria?: string[];
  attempts: GuardianPlayerLevelDetailAttempt[];
};

export type GuardianPlayerLevelDetailData = {
  playerId: string;
  playerName: string;
  level: number;
  progressPercent: number;
  levelStatusLabel: string;
  pins: GuardianPlayerLevelDetailPin[];
  selectedPinId: number;
};
